export const wasClickOutsideElement = (event, target) => !event.composedPath().includes(target);
export const wasClickInsideElement = (event, target) => event.composedPath().includes(target);
export const getPrefix = (element) => element.tagName.toLowerCase().split('-')[0];
